'use strict';
const _ = require("lodash");
const $ = require("jquery");
const Backbone = require("backbone");
const PubSub = require('./../PubSub');

var { isMobile } = require('../util/is-mobile');
const { pagePath, ptype, franchise, event } = require("../constants/_ad");

module.exports = Backbone.Model.extend({
	defaults: {
		ads: []
	},
	video: null,
	/**
	 *
	 */
	initialize: function (attrs, options) {
		_.bindAll(this, 'createAd'/*, 'loadScript'*/);

		window.BidBarrel.initialize({
			dfpPath: {
				device: isMobile.any() ? 'm' : '',
				pagePath: pagePath
			},

			targeting: {
				auto: true,
				cookie: {
						surround: true,
						consolidate: true
				}
			},

			pageTargeting: {
				ptype: ptype,
				env: 'prod', 
				franchise: franchise,
				event: event
			}
		});

		this.listenTo(PubSub, 'createAd', this.createAd.bind(this));
	},
	/**
	 *
	 */
	removeAd: function (targetElement) {
		var ads = _.clone(this.get('ads'), true);
		ads.pop(ads.indexOf(targetElement));
		this.set({ ads: ads });
	},
	/**
	 *
	 */
	createAd: function (adId, sponsor) {
    try {
			if (window.cbsoptanon && window.cbsoptanon.onAdsReady) {
				window.cbsoptanon.onAdsReady(function () {

					window.BidBarrel.auction([
						adId
					]);
					
					if( sponsor ) {
						window.BidBarrel.setTargeting( {
							sponsor: sponsor
						}, [ adId ] )
					}

				}.bind(this));
			}
    } catch(err) {
      console.error(err);
    }
	},
	removeAd: function(adIds) {
		if( window.BidBarrel ) {
			if( !Array.isArray( adIds ) ) {
				adIds = [ adIds ];
			}

			window.BidBarrel.destroySlots(adIds);
		}
	}
})



// WEBPACK FOOTER //
// ./app/scripts/models/ad.js